<template>
  <div class="collapse" :class="{ 'is-active': active }">
    <div class="collapse__header">
      <h2 class="black-text collapse__title">{{ title }}</h2>
      <button @click.prevent.stop="$emit('toggle')" class="collapse__btn">
        <i v-if="active" class="el-icon-minus black-text"></i>
        <i v-else class="el-icon-plus black-text"></i>
      </button>
    </div>
    <div class="collapse__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "OmniaCollapse",

  props: {
    title: {
			type: String,
      required: true,
    },
		active: {
			type: Boolean,
			required: true
		}
  },
};
</script>

<style lang="scss" scoped>
.collapse {
  margin-top: 16px;

  &__header {
    border-bottom: 1px solid #ebebeb;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    padding: 10px 0;
    margin: 0;
  }

  &__btn {
    display: inline-block;
    border: none;
    background-color: transparent;
    cursor: pointer;
    padding: 12px;
    font-size: 14px;
    transition: all 0.3s ease-out;
    color: #4e5a64;

    &:hover {
      color: #000;
    }
  }

  &__content {
    opacity: 0;
    height: 0;
    padding: 0;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 0.3s ease-out;
  }

  &.is-active &__content {
    padding: 10px 0;
		height: auto;
		opacity: 1;
    transform: scaleY(1);
  }
}
</style>
